// IMPORTANT: The three definitions below must be kept in sync
// anytime this file is modified.

export const LeftNavStyle: {
  ALWAYS_COLLAPSED: "ALWAYS_COLLAPSED";
  EXPAND_ON_HOVER: "EXPAND_ON_HOVER";
  ALWAYS_EXPANDED: "ALWAYS_EXPANDED";
} = {
  ALWAYS_COLLAPSED: "ALWAYS_COLLAPSED",
  EXPAND_ON_HOVER: "EXPAND_ON_HOVER",
  ALWAYS_EXPANDED: "ALWAYS_EXPANDED",
};

// For use with typescript types.
export type LeftNavStyle = keyof typeof LeftNavStyle;

// For use with enums in zod schemas (https://zod.dev/?id=zod-enums).
export const LEFT_NAV_STYLE_VALUES = [
  "ALWAYS_COLLAPSED",
  "EXPAND_ON_HOVER",
  "ALWAYS_EXPANDED",
] as const;
